<template>
<!-- 付费推广 -->
<div class="viewContainer">
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <!-- <el-tab-pane label="付费购买客户" name="first"/> -->
    <el-tab-pane label="付费分享推广" name="second"/>
  </el-tabs>
  <!-- 付费购买客户 -->
  <div class="main_container" v-show="activeName == 'first'">
    <el-row :gutter="20">
      <el-col :span="8">
        <h3>充值信息：</h3>
        <el-form>
          <el-form-item label="推广客户单价：" style="width:80%;" label-width="120px">
            <el-input v-model="tgkhdj" placeholder="请输入" style="width:70%" disabled>
            <i slot="suffix" style="margin-right: 10px;">元/条</i>
            </el-input>
          </el-form-item>
          <el-form-item label="推广条数：" style="width:80%;" label-width="120px">
            <el-input v-model="tgts" placeholder="请输入购买条数" style="width:70%" onkeyup="this.value=this.value.replace(/\D|^0/g,'')">
            <i slot="suffix" style="margin-right: 10px;">条</i>
            </el-input>
          </el-form-item>
          <el-form-item label="微信手续费6‰：" style="width:80%;" label-width="120px">
            <el-input v-model="wxsxf" placeholder="请输入" style="width:70%" disabled>
            <i slot="suffix" style="margin-right: 10px;">元</i>
            </el-input>
          </el-form-item>
          <el-form-item label="需充值金额：" style="width:80%;" label-width="120px">
            <el-input v-model="xczje" placeholder="请输入" style="width:70%" disabled>
              <i slot="suffix" style="margin-right: 10px;">元</i>
            </el-input>
          </el-form-item>
        </el-form>
        <ul class="zysmUl">
          <b>充值说明：</b>
          <li>1. 未使用金额可随时退款；</li>
          <li>2. 充值千分之6的手续费是微信收取。</li>
        </ul>
        <div class="upBtn"><el-button type="danger" @click="chongzhi(1)">充值</el-button></div>
      </el-col>
      <!-- <el-col :span="8">
        <h3>有效客户认定规则：</h3>
        <el-form>
          <el-form-item label="需进店浏览次数：" style="width:60%;" label-width="130px">
            <el-select v-model="xjdllcs" filterable placeholder="请选择" style="width:80%">
              <el-option v-for="(item,index) in xjdllcsArr" :key="index" :label="item.gradeName" :value="item.grade"/>
            </el-select>
          </el-form-item>
          <el-form-item label="每日付费推广上限：" style="width:80%;" label-width="130px">
            <el-input v-model="mrfftgsx" placeholder="请输入" style="width:52%" :disabled="buxian"/> 条
            <el-checkbox v-model="buxian" style="margin-left: 20px;">不限</el-checkbox>
          </el-form-item>
        </el-form>
        <ul class="zysmUl">
          <b style="color: #F56C6C;">重要提示：</b>
          <li>1.满足以上规则的客户，将自动进行付费推广获得客户信息。</li>
          <li>2.当每日付费推广条数使用完后，再有符合推广规则的客户信息，不再自动付费推广；超出自动付费上限的有效客户，商家可进行手动购买。</li>
        </ul>
        <div class="upBtn"><el-button type="danger" @click="baocun()">保存</el-button></div>
      </el-col> -->
      <el-col :span="8">
        <!-- <h3>客户信息通知：</h3>
        <div style="margin-left: 20px;">
          <p>微信扫一扫，关注公众号；每天定时推送本店铺客户数据情况。</p>
          <img src="../../assets/img/gongzhong.jpg" style="width: 200px;"/>
        </div> -->
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <!-- table 列表 -->
    <div class="table_inner_container">
      <div style="margin-bottom: 20px;"><b>充值记录：</b><span style="color: #F56C6C;margin-right: 20px;">本店累计充值 {{showRechargeCount}}次，累计金额：{{showAmount}}元</span><span style="color: #409EFF;">当前可付费推广客户数余额为：{{showLeave}} 条</span></div>
      <el-table :data="rechargeRecordList" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60px">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="充值时间" align="center">
          <template scope="scope">{{scope.row.rechargTime}}</template>
        </el-table-column>
        <el-table-column label="客户单价（元）" align="center">
          <template scope="scope">{{scope.row.price}}</template>
        </el-table-column>
        <el-table-column label="推广条数" align="center">
          <template scope="scope">{{scope.row.quantity}}</template>
        </el-table-column>
        <el-table-column label="充值金额（含手续费/元）" align="center">
          <template scope="scope">{{scope.row.recharge}}</template>
        </el-table-column>
        <el-table-column label="已付费推广条数" align="center">
          <template scope="scope">{{scope.row.paidQuantity}}</template>
        </el-table-column>
        <el-table-column label="剩余可用条数" align="center">
          <template scope="scope">{{scope.row.leave}}</template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template scope="scope">{{scope.row.remarks}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="tuikuan(scope.row.id)" class="handle" v-show="scope.row.refund == 0 && scope.row.leave>0">退款</span>
            <span @click="seeOrder(scope.row.id,1)" class="handle"> <i class="el-icon-view"></i>查看</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page="pageIndex" :page-size="10" :total="czjlTotal"/>
      </el-col>
    </div>
  </div>
  <!-- 付费分享推广 -->
  <div class="main_container" v-show="activeName == 'second'">
    <div v-if="isshowfffxtg">
      <section class="model_section">
        <p class="model_top_title">推广记录：</p>
        <span style="margin-right: 10px;">本店已分享推广 {{fffxtgTotal}} 次</span><span style="color: #F56C6C;">【未使用金额推广到期后自动退款】</span>
        <el-button type="danger" @click="seepeizhi('')" style="float: right;margin: 6px 10px 0 0;">新增推广</el-button>
      </section>
      <div class="table_container">
        <el-table :data="fffxtgList" stripe border>
          <el-table-column prop="num" label="序号" align="center" width="60px">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="分享内容" align="center">
            <template scope="scope">{{scope.row.taskname}}</template>
          </el-table-column>
          <el-table-column label="分享规则" align="center">
            <template scope="scope">{{scope.row.tasktypename}}</template>
          </el-table-column>
          <el-table-column label="有效期限" align="center" width="180px">
            <template scope="scope">{{scope.row.begindate}}-{{scope.row.enddate}}</template>
          </el-table-column>
          <el-table-column label="金额（元）" align="center" width="100px">
            <template scope="scope">{{scope.row.bonus}}</template>
          </el-table-column>
          <el-table-column label="份数" align="center">
            <template scope="scope">{{scope.row.consume}}/{{scope.row.totalcount}}</template>
          </el-table-column>
          <el-table-column label="金额（元）" align="center">
            <template scope="scope">{{scope.row.totalprice}}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">
              <span v-show="scope.row.status==1">待开始</span>
              <span v-show="scope.row.status==2">已退款</span>
              <span v-show="scope.row.status==3">进行中</span>
              <span v-show="scope.row.status==4">已结束</span>
            </template>
          </el-table-column>
          <el-table-column label="分享文案" align="center" width="160px">
            <!-- <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p :class=" scope.row.sharecopy.length > 50 ? 'pkuandu' : ''">{{ scope.row.sharecopy }}</p>
                <div slot="reference" class="name-wrapper"> {{ scope.row.sharecopy }} </div>
              </el-popover>
            </template> -->
            <template scope="scope">
              <span class="spanList" :title="scope.row.sharecopy">{{scope.row.sharecopy}}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" width="100px">
            <template scope="scope">{{scope.row.remark}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="200px">
            <template scope="scope">
              <span @click="seepeizhi(scope.row)" class="handle"> <i class="el-icon-view"></i>查看配置</span>
              <span @click="seeOrder(scope.row.brrid,2)" class="handle"> <i class="el-icon-view"></i>查看记录</span>
              <span @click="tuikuan(scope.row.id)" class="handle" v-show="scope.row.refund == 0 && scope.row.leave>0">退款</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handlefffxtg"
        :current-page="fffxtgIndex" :page-size="10" :total="fffxtgTotal" style="margin:10px 0;float:right"/>
      </div>
    </div>
    <div v-else v-loading="loading" element-loading-text="分享推广配置中..." element-loading-spinner="el-icon-loading">
      <el-row :gutter="20" style="margin: 0 0 0 10px;">
        <el-col :span="10">
          <h3>分享赚钱配置</h3>
          <el-form>
            <el-form-item label="有效期限：" style="width:80%;margin-bottom: 5px;" label-width="100px">
              <el-date-picker type="daterange" v-model="value6" :title="value6" @change="changetime" :disabled="seefffxtg"
              value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              style="width:80%;background: #fff;border:1px solid #eee;" :picker-options="pickerOptions"/>
            </el-form-item>
            <el-form-item label="分享规则：" style="width:80%;margin-bottom: 5px;" label-width="100px">
              <el-radio-group v-model="fxdpyq" :disabled="seefffxtg">
                <el-radio v-for="item in tasktyps" :key="item.bttid" :label="item.bttid" style="margin-right: 15px;">{{item.tasktypename}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="分享文案：" style="width:80%;" label-width="100px">
              <el-input type="textarea" v-model="recharge.remark" :rows="3" placeholder="请输入分享文案内容"
              maxlength="100" show-word-limit style="width:80%" :disabled="seefffxtg"/>
            </el-form-item>
            <el-form-item label="单份奖励：" style="width:80%;" label-width="100px">
              <el-input v-model="rewardTwo" placeholder="请输入" style="width:80%" maxlength="6"
              onkeyup="this.value=this.value.replace(/\D|^0/g,'')" :disabled="seefffxtg">
              <i slot="suffix" style="margin-right: 10px;">元</i>
              </el-input>
            </el-form-item>
            <el-form-item label="奖励份数：" style="width:80%;" label-width="100px">
              <el-input v-model="recharge.totalcount" placeholder="请输入奖励份数" style="width:80%"
              onkeyup="this.value=this.value.replace(/\D|^0/g,'')" :disabled="seefffxtg" maxlength="6"/>
            </el-form-item>
            <el-form-item label="分享要求：" style="width:80%;" label-width="100px">
              <!-- <div>
                <div v-if="get_description('pyq').length > 0" style="margin-bottom: -5px;">【朋友圈】</div>
                <div v-for="(item,index) in get_description('pyq')" :key="index">
                  <div style="color: #999;line-height: 25px;">{{index+1}}.{{item}}</div>
                </div>
                <div v-if="get_description('wxq').length > 0" style="margin-bottom: -5px;">【微信群】</div>
                <div v-for="(item,index) in get_description('wxq')" :key="index">
                  <div style="color: #999;line-height: 25px;">{{index+1}}.{{item}}</div>
                </div>
              </div> -->
              <div v-if="tasktyps.length>0">
                <ul v-for="(desc, index) in tasktyps.find(t => t.bttid == fxdpyq).descriptions" :key="index">
                  <li v-if="desc.taskdesc.startsWith('【朋友圈】') || desc.taskdesc.startsWith('【微信群】')" style="font-weight: bold;">
                    {{ desc.taskdesc }}
                  </li>
                  <li v-else style="color: #999;line-height: 30px;">
                    {{ desc.taskdesc }}
                  </li>
                </ul>
              </div>
            </el-form-item>
            <div style="width: 80%;margin-left: 15px;">
              <!-- <p style="color: #999;"><b style="font-size: 20px;color: #333;">推广费：{{Math.ceil(recharge.totalprice*100)/100}}元</b>（含微信收取{{wxrate*1000}}‰手续费）</p> -->
              <p style="color: #999;"><b style="font-size: 20px;color: #333;">推广费：{{Math.ceil(recharge.totalprice*100)/100}}元</b></p>
            </div>
          </el-form>
        </el-col>
        <el-col :span="10">
          <h3>付费推广目的：</h3>
          <ul>
            <li style="line-height: 32px;" v-for="(item, index) in ckfxjxj" :key="index">{{item.name}}</li>
            <li style="margin-top: 5px;">4.示例截图</li>
            <ul class="videoandpic" v-if="tasktyps.length>0">
              <!--  @click="handleplay(item)" -->
              <li v-for="(item, index) in tasktyps.find(i=>i.bttid==fxdpyq).examples" :key="index">
                <!-- <el-image :src="baseOssUrl+item.videoimg" style="width: 100px; height: 100px"/> -->
                <i class="el-icon-video-play mengceng" v-show="item.mediatype == 2"/>
                <el-image :src="baseOssUrl+item.mediapath" fit="cover" style="width: 100px; height: 100px"
                @click="handleClickItem" :preview-src-list="[baseOssUrl+item.mediapath]"/>
              </li>
            </ul>
          </ul>
          <h3 style="line-height: 0;margin-bottom: 20px;">创客范围</h3>
          <span style="float: left;">按从事行业：</span>
          <div style="width: 800px;">
            <el-checkbox-group v-model="formmenuOne" @change="handleCheckedCities" style="margin-bottom: 20px;">
              <el-checkbox v-for="item in industry" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
          
          <div style="height: 200px;display: flex;" v-show="formmenuOne.find(i=>i==2)">
            <span style="float: left;">按建材品类：</span>
            <div style="overflow-y: scroll;display: grid;padding: 0 10px 0 0;">
              <el-checkbox v-model="checkAlltwo" :indeterminate="isIndeterminateTwo" @change="handleCheckAllChange(checkAlltwo,2)">
                全部
              </el-checkbox>
              <el-tree ref="tree" show-checkbox :data="category" node-key="id" style="margin-top: 5px;"
              highlight-current :props="defaultProps" class="cktree" :default-checked-keys="formmenuTwo"/>
            </div>
          </div>
          <!-- <div style="width: 500px;background: #F2F2F2;padding: 10px 0;float: left;">
            <el-row style="display: flex;justify-content: space-between;padding-bottom: 10px;">
              <el-col :span="11"><b>按行业选择</b></el-col>
              <el-col :span="11"><b>按品类选择</b></el-col>
            </el-row>
            <el-row style="height: 200px;display: flex;justify-content: space-between;">
              <el-col :span="11" style="overflow-y: scroll;display: grid;background: #fff;padding: 10px 0 0 24px;">
                <el-checkbox v-model="checkAllone" :indeterminate="isIndeterminateOne" @change="handleCheckAllChange(checkAllone,1)"> 全部 </el-checkbox>
                <el-checkbox-group v-model="formmenuOne" @change="handleCheckedCities" style="margin-top: -10px;">
                  <el-checkbox v-for="item in industry" :label="item.id" :key="item.id" style="line-height: 30px;">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="11" style="overflow-y: scroll;display: grid;background: #fff;padding: 10px 0 0 24px;">
                <el-checkbox v-model="checkAlltwo" :indeterminate="isIndeterminateTwo" @change="handleCheckAllChange(checkAlltwo,2)"> 全部 </el-checkbox>
                <el-tree ref="tree" show-checkbox :data="category" node-key="id" style="margin-top: 5px;"
                highlight-current :props="defaultProps" class="cktree" :default-checked-keys="formmenuTwo"/>
              </el-col>
            </el-row>
          </div> -->
        </el-col>
      </el-row>
      <div style="width: 100%;margin: 20px auto;text-align: center;">
        <el-button @click="isshowfffxtg = true">{{ seefffxtg?'返回':'取消' }}</el-button>
        <el-button type="danger" @click="chongzhi(2)" v-show="!seefffxtg">确定</el-button>
      </div>
    </div>
    
  </div>
  <!-- 请使用微信扫码支付 -->
  <el-dialog title='请使用微信扫码支付' :visible.sync="qsywxsmzf" @closed="clearWxzf" width="20%" center>
    <div style="text-align: center;">
      <p style="font-size: 26px;font-weight: bold;" v-if="leixing==1">{{xczje}}  元</p>
      <p style="font-size: 26px;font-weight: bold;" v-else>{{Math.ceil(recharge.totalprice*100)/100}}  元</p>
      <img :src="wxSmzfImg" style="width: 200px;"/>
    </div>
  </el-dialog>
  <!-- 退款提示 -->
  <el-dialog title='退款提示' :visible.sync="refund" @closed="clearTk" width="25%" center>
    <p>确定进行退款操作吗？如确定申请退款，退款申请成功，余额将返回原支付微信账户，请注意查收。</p>
    <div style="text-align:center">
      <el-button @click="refund = false">取消</el-button>
      <el-button type="danger" @click="handleTk()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 已付费推广客户明细 右侧抽屉组件 -->
  <el-drawer title="已付费推广客户明细" custom-class="registrationRecord" :visible.sync="visibleSeeLlmx" size="48%">
    <el-table :data="seeLlmxList" style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <template v-if="czxxType==1">
        <el-table-column property="mobile" label="客户手机号" align="center" key="1"/>
        <el-table-column property="lastTime" label="最近活跃时间" align="center" key="2"/>
        <el-table-column property="source" label="来源渠道" align="center" key="3"/>
      </template>
      <template v-else>
        <el-table-column property="phone" label="创客" align="center" key="4"/>
        <el-table-column property="createtime" label="奖励发放时间" align="center" key="5"/>
      </template>
    </el-table>
    <!-- 已付费推广客户明细-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handleLlmx"
      :current-page="pageIndexLlmx" :page-size="10" :total="totalRowsCountLlmx" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 图片查看 -->
  <el-dialog title='图片查看' :visible.sync="largeImage" @closed="clearImg" center>
    <div class="imgDialog">
      <img :src="showImageUrl"/>
    </div>
  </el-dialog>
  <el-dialog title="视频播放" :visible.sync="videoVisible" @close="closeDialog" center width="35%">
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
  
  <!-- 确认提示 -->
  <el-dialog title='确认提示' :visible.sync="fufeidialog" width="30%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 20px 0; font-size: 16px;">需支付以下数额推广费，确定支付并创建本次推广吗?</p>
      <b style="font-size: 18px;">-{{zysj}} 元</b>
    </div>
    <div style="text-align:center;margin-top: 20px;">
      <el-button @click="fufeidialog = false">取消</el-button>
      <el-button type="danger" @click="qdfufeu()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 充值提示 -->
  <el-dialog title='充值提示' :visible.sync="chongzhidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 30px 0; font-size: 16px;">{{chognzhitishi}}</p>
    </div>
    <div style="text-align:center;">
      <el-button @click="chongzhidialog = false">取消</el-button>
      <el-button type="danger" @click="quchongzhi()">去充值</el-button>
    </div>
  </el-dialog>

  <!-- 操作完成 -->
  <el-dialog title='操作完成' :visible.sync="czwcDialog" width="25%" center
  :showClose="false" :close-on-click-modal="false">
    <div style="text-align: center;">
      <i class="el-icon-circle-check" style="font-size: 100px;color: #67C23A;"/>
      <div style="margin: 18px 0;">
        <span style="font-size: 20px;">分享推广配置成功</span>
      </div>
    </div>
    <div style="text-align:center;">
      <el-button type="danger" @click="qdczcg()" style="padding: 0 3em; line-height: 3.2em;">确定</el-button>
    </div>
  </el-dialog>
  <!-- 请选择店铺 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="handleChangedptype">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { payment, userIdentity, getfilterlist } from "../../api/newOss";
import { configSave, configtaskType } from "../../api/activityFormList";
import { getBrandTypePrice, postAddRechargeTable, rechargeState, getGrade, postAddRecognitionRules,
  getRechargeTable, getRechargeTotal, recognitionRulesDetails, paidPromotionRefund, getDeduction,
  postshoptask, postconsume, isrecharge } from "../../api/shopWindow";
export default {
  name: "paidPromotion",
  mixins: [alertTrends],
  data() {
    return {
      baseOssUrl: localStorage.BaseOssUrl,
      dialogVisibleadd: false, // 请选择店铺
      bbid:'',  // 店铺id
      bbtype: '', // 店铺类型
      options1: [],
      tgkhdj: '', // 推广客户单价
      tgts: '', // 推广条数
      // wxsxf: '', // 微信手续费
      // xczje: '', // 需充值金额
      lxId: '', // 付费推广id
      qsywxsmzf: false, // 请使用微信扫码支付
      wxSmzfImg: '', // 二维码
      timer: null, // 轮询
      startTime: 0, // 初始开始请求时间

      xjdllcs: '', // 需进店浏览次数
      xjdllcsArr: [],
      mrfftgsx: '', // 每日付费推广上限
      buxian: false, // 不限
      
      showRechargeCount: '', // 累计充值
      showAmount: '', // 累计金额
      showLeave: '', // 剩余条数
      rechargeRecordList: [], // 充值记录list
      pageIndex: 1,
      czjlTotal: 0,
      czxxId: '', // 充值信息id
      czxxType: '', // 区分是哪一个表格
      refund: false, // 退款提示
      visibleSeeLlmx: false, // 已付费推广客户明细-抽屉
      seeLlmxList: [], // 已付费推广客户明细-列表
      pageIndexLlmx: 1,
      totalRowsCountLlmx: 0,

      activeName: 'second', // tab切换标识
      value6: "", // 有效期限
      date1: "",
      date2: "",
      // 活动时间限制
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()-8.64e7;
        },
      },
      fxdpyq: 1, // 分享到朋友圈
      rewardTwo: '', // 单份奖励
      recharge: {
        totalprice: 0,
      },
      tasktyps: [],
      wxrate: 0.006, // 手续费
      ckfxjxj: [
        {name: '1.鼓励创客将本活动进行分享，起到宣传活动的作用；'},
        {name: '2.创客按照分享要求进行分享，并按照要求截图上传给商家；'},
        {name: '3.商家对分享的有效性进行辨别审核，审核通过后奖励直接发放给创客。'},
      ],
      largeImage: false, // 图片查看
      showImageUrl: "",
      videoVisible: false, // 视频弹框
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      
      fffxtgCount: '', // 本店累计充值
      fffxtgList: [], // 付费分享推广list
      fffxtgIndex: 1,
      fffxtgTotal: 0,
      leixing: '', // 区分充值
      
      // 按行业选择
      checkAllone: true,
      isIndeterminateOne: false,
      formmenuOne: [],
      industry: [],
      // 按品类选择
      checkAlltwo: true,
      isIndeterminateTwo: false,
      formmenuTwo:[],
      mydata: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      category: [],
      isshowfffxtg: true, // 付费分享推广-列表
      seefffxtg: false, // 查看标识
      fufeidialog: false, // 确认提示
      zysj: 0, // 金额
      chongzhidialog: false, // 充值提示
      chognzhitishi: '', // 提示文案

      loading: false,
      czwcDialog: false,
    };
  },
  computed: {
    // 计算微信手续费
    wxsxf() {
      let jswxsxf = this.tgkhdj * this.tgts / 0.994 - (this.tgkhdj * this.tgts);
      return jswxsxf.toFixed(2);
    },
    // 计算需充值金额
    xczje() {
      let jsxczje = this.tgkhdj * this.tgts / 0.994;
      // return jsxczje.toFixed(2);
      return Math.ceil(jsxczje * 100) / 100; // 进一位 并 保留两位小数
    }
  },
  watch: {
    // 单份奖励 = 充值金额
    'rewardTwo'(newV,oldV) {
      // this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount / (1 - this.wxrate);
      this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount;
    },
    // 奖励份数 = 充值金额
    'recharge.totalcount'(newV,oldV) {
      // this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount / (1 - this.wxrate);
      this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount;
    },
  },
  methods: {
    // 切换 付费购买客户 & 付费分享推广
    handleClick(tab){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      if(tab.name=='first'){
        this.pageIndex = 1;
        this.getinit();
      }else {
        this.chaxun();
      }
    },
    // 获取描述
    get_description(type){
      let pyq = []
      let wxq = []
      let all = this.tasktyps.find(i=>i.bttid==this.fxdpyq).descriptions.map(i=>{
        if(i.sort/10<1){
          pyq.push(i.taskdesc)
        }else{
          wxq.push(i.taskdesc)
        }
      })
      if (type=='pyq'){
        return pyq
      }else{
        return wxq
      }
    },
    // 获取 行业 & 品类
    getfilterlist(){
      getfilterlist('').then(data => {
        if (data.resultCode == 1) {
          this.industry = data.resultObj.industry; // 行业集合
          this.category = data.resultObj.category; // 品类集合
        }
      })
    },
    getTreeselect() {
      this.$refs.tree.setCheckedKeys(this.formmenuTwo);  //通过 keys 设置目前勾选的节点，使用此方法必须设置 node-key 属性
      // this.mydata = this.convertTreeData(this.category);//因为下面要判断数组长度，树的结构里包含children，所以要将其展开。
      //与全选关联起来，判断是否全部选中还是部分选中
      let checkedCount = this.formmenuTwo.length;
      this.checkAlltwo = checkedCount === this.category.length;
      this.isIndeterminateTwo = checkedCount > 0 && checkedCount < this.category.length;
    },
    // tree 结构转化成一维数组
    convertTreeData(menuOptions) {
      for (let i = 0; i < menuOptions.length; i++) {
        if (menuOptions[i].children != undefined) {
          const temp = menuOptions[i].children;
          delete menuOptions[i].children;
          menuOptions = menuOptions.concat(temp);
        }
      }
      return menuOptions;
    },
    handleCheckedCities(value) {
      let checkedCount = value.length;
      this.checkAllone = checkedCount === this.industry.length;
      this.isIndeterminateOne = checkedCount > 0 && checkedCount < this.industry.length;
    },
    // 全选 / 全不选
    handleCheckAllChange(val,type) {
      if(type==1){
        // this.checkAllone = val;
        // if (this.checkAllone) {
        //   this.$refs.tree.setCheckedNodes(this.industry);
        // } else {
        //   this.$refs.tree.setCheckedKeys([]);
        // }
        const all = this.industry.map(item => {
          return item.id
        })
        this.formmenuOne = val ? all : [];
        this.isIndeterminateOne = false;
      }
      if(type==2){
        this.checkAlltwo = val;
        if (this.checkAlltwo) {
          this.$refs.tree.setCheckedNodes(this.category);
        } else {
          this.$refs.tree.setCheckedKeys([]);
        }
        this.isIndeterminateTwo = false;
      }
    },
    // 查看大图
    handleplay(itemI) { // 媒体素材类型 1=图片 2=视频
      if(itemI.mediatype ==1) {
        this.largeImage = true;
        this.showImageUrl = localStorage.BaseOssUrl + itemI.videoimg;
      }
      if(itemI.mediatype ==2) {
        this.palySeevideo(localStorage.BaseOssUrl + itemI.mediapath);
      }
    },
    // 关闭查看大图
    clearImg(){
      this.largeImage = false;
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause();
    },
    changetime() {
      if (this.value6 + "" == "null") {
        this.value6 = ["", ""];
      }
      this.date1 = this.value6[0];
      this.date2 = this.value6[1];
    },
    // 付费购买客户list
    getinit() {
      let addParams = {
        BusinessID: this.bbid, // 店铺id
        PageNumber: this.pageIndex,// 页码
        PageSize: 10 // 每页行数
      };
      getRechargeTable(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.rechargeRecordList = data.resultObj.resultObj;
            this.czjlTotal = data.resultObj.rowsCount; // 总数
          } else {
            this.rechargeRecordList = [];
            this.czjlTotal = 0;
          }
        } else {
          this.rechargeRecordList = [];
          this.czjlTotal = 0;
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getinit();
    },
    // 付费分享推广list
    getfffxtgList() {
      let addParams = {
        shopid: this.bbid, // 店铺id
        pageindex: this.fffxtgIndex,// 页码
        pagesize: 10 // 每页行数
      };
      postshoptask(addParams).then(data => {
        if (data.resultCode == 1) {
          this.fffxtgList = data.resultObj.list;
          this.fffxtgTotal = data.resultObj.totalcount; // 总数
        } else {
          this.fffxtgList = [];
          this.fffxtgTotal = 0;
        }
      })
    },
    // 分页
    handlefffxtg(val) {
      this.fffxtgIndex = val;
      this.getfffxtgList();
    },
    // 查询
    chaxun(){
      this.fffxtgIndex = 1;
      this.getfffxtgList(); // 付费分享推广list
    },
    // 获取推广客户单价
    amountOfmoney() {
      var obj = {
        bbid: this.bbid, // 店铺id
      };
      getBrandTypePrice(obj).then(data => {
        if (data.resultCode == 1) {
          this.tgkhdj = data.resultObj; // 金额
        }
      });
    },
    // 充值
    chongzhi(valType) {
      if(valType==1){
        if (this.tgts == "") {
          this.showAlert('请输入推广条数');
          return false;
        }
        var obj = {
          BusinessID: this.bbid, // 店铺id
          Price: Number(this.tgkhdj), // 客户单价
          Quantity: Number(this.tgts), // 推广条数
          OperatorID: localStorage.Id, // 操作人id
        };
        postAddRechargeTable(obj).then(data => {
          if (data.resultCode == 1) {
            this.lxId = data.resultObj.id; // 付费推广id
            // 调取二维码
            this.erweima(1);
          }
        });
      }
      if(valType==2){
        if (this.value6 == "") {
          this.showAlert('请选择有效期限');
          return false;
        }
        if (this.recharge.remark == "") {
          this.showAlert('请输入分享文案');
          return false;
        }
        if (this.recharge.totalcount == "") {
          this.showAlert('请输入奖励份数');
          return false;
        }
        if(this.formmenuOne.length==0){
          this.showAlert('创客范围请至少选择一个从事行业');
          return false;
        }
        let plarr=this.$refs.tree.getCheckedKeys(this.formmenuTwo).concat(this.$refs.tree.getHalfCheckedKeys());
        let params={
          tasktype: 1, // 类型 1=分享赚钱-店铺充值 2=分享赚钱-活动充值  5=分享赚钱-幸运购
          price: Number(this.rewardTwo), // 单份奖励
          num: Number(this.recharge.totalcount), // 份额
          remark: this.recharge.remark, // 分享文案(备注)
          shopid: this.bbid, // 店铺ID
          activityid: 0, // 活动ID
          operatorid: Number(localStorage.Id), // 操作人id
          begintime: this.date1, // 有效期-开始 格式：yyyy-MM-dd
          endtime: this.date2, // 有效期-结束 格式：yyyy-MM-dd
          // bttids: this.fxdpyq==true?'1':[], // 任务类型ID 多个用英文逗号隔开
          bttids: this.fxdpyq, // 任务类型ID 多个用英文逗号隔开
          industry: this.formmenuOne, // 创客行业ID集合
          category: plarr, // 员工创客所属店铺品类ID集合
        }
        configSave(params).then(data => {
          if (data.resultCode == 1) {
            this.lxId = data.resultObj; // 付费推广id
            // 调取二维码
            this.erweima(2);
          }
        })
      }
    },
    // 关闭充值弹框
    clearWxzf(){
      this.qsywxsmzf = false;
      clearTimeout(this.timer)
    },
    // 二维码接口
    erweima(lx){
      this.leixing = lx;
      if(this.leixing==1){
        var obj = {
          attach: 'paidpromotionorder,' + this.lxId
        };
      }
      if(this.leixing==2){
        var obj = {
          price: this.recharge.totalprice, // 支付金额 单位：元 （店铺分享赚钱必传）
          attach: 'shoptaskorder,' + this.lxId,
          operatorid: localStorage.Id, // 操作人
          isconfirm: 0, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
        };
      }
      payment(obj,3,this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.fufeidialog=true;
          this.zysj = data.resultObj; // 返回金额 - 待确认支付：返回待支付金额 单位：元 确认支付：>0表示成功
          // this.qsywxsmzf = true;
          // this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片
          // this.startTime = new Date().getTime() // 获取触发轮询时的时间
          // this.inquireData() // 调用轮询接口,开始进行轮询
        }else if(data.resultCode == 4){
          this.chongzhidialog=true; // 充值提示
          this.chognzhitishi=data.resultObj; // 提示文案
        }else{
          this.showAlert(data.resultObj);
        }
      });
    },
    // 确定
    qdfufeu(){
      let obj = {
        price: this.recharge.totalprice, // 支付金额 单位：元 （店铺分享赚钱必传）
        attach: 'shoptaskorder,' + this.lxId,
        operatorid: localStorage.Id, // 操作人
        isconfirm: 1, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
      };
      payment(obj,3,this.bbid).then(data => {
        this.loading = true;
        this.fufeidialog=false;
        setTimeout(() => {
          this.loading = false;
          if (data.resultCode == 1) {
            this.czwcDialog=true;
            // this.showAlert('分享推广配置成功', 'success');
          }
        }, 5000)
      });
    },
    // 确定操作成功
    qdczcg(){
      this.chaxun();
      this.czwcDialog=false;
      this.isshowfffxtg=true;
    },
    // 去充值
    quchongzhi(){
      this.$router.push({
        path: "/vmacount", // 跳转店铺钱包
        query: { shopid: this.bbid }
      });
    },
    // 轮询请求
    inquireData() {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.startTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      let lxObj = {
        id: this.lxId, // 付费推广id
      }
      let thisApi = this.leixing==1?rechargeState:isrecharge;
      thisApi(lxObj).then(res => {
        if (res && res.resultCode === 1) {
          // true=成功、false=失败
          if(res.resultObj) {
            this.qsywxsmzf = false; // 二维码弹窗消失
            this.showAlert('充值成功', 'success');
            this.getinit(); // 充值记录列表
            this.chaxun();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 需进店浏览次数
    browse() {
      getGrade('obj').then(data => {
        if (data.resultCode == 1) {
          this.xjdllcsArr = data.resultObj;
        }
      });
    },
    // 保存
    baocun() {
      var obj = {
        BusinessID: this.bbid, // 店铺id
        Views: this.xjdllcs, // 有效浏览次数
        PPCMAX: this.mrfftgsx, // 每日付费推广上限,整数
        State: this.buxian==true?1:0, // 不限开关 0 没有选择 1 选择不限
        OperatorID: localStorage.Id, // 操作人
      };
      postAddRecognitionRules(obj).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('保存成功', 'success');
        }
      });
    },
    // 充值信息统计
    rechargeInfoStatis() {
      var obj = {
        BusinessID: this.bbid, // 店铺ID
      };
      getRechargeTotal(obj).then(data => {
        if (data.resultCode == 1) {
          this.showRechargeCount = data.resultObj.rechargeCount; // 充值次数
          this.showAmount = data.resultObj.amount; // "332.81" 累计金额
          this.showLeave = data.resultObj.leave; // 付费推广剩余条数
        }
      });
    },
    // 店铺推广规则信息详情
    promotionRules() {
      var obj = {
        BusinessID: this.bbid, // 店铺ID
      };
      recognitionRulesDetails(obj).then(data => {
        if (data.resultCode == 1) {
          this.xjdllcs = data.resultObj.views; // 有效浏览次数
          this.mrfftgsx = data.resultObj.ppcmax; // 每日推广条数 不限开关 0 没有选择 1 选择不限
        }
      });
    },
    // 退款
    tuikuan(rowId) {
      this.refund = true;
      this.czxxId = rowId;
    },
    // 确定退款
    handleTk() {
      // let obj = {
      //   id: this.czxxId, // 付费推广id
      // };
      paidPromotionRefund('obj',this.czxxId).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('退款成功', 'success');
          this.refund = false;
          this.getinit();
        }
      });
    },
    // 关闭退款提示
    clearTk() {
      this.refund = false;
    },
    // 查看已付费推广客户明细
    seeOrder(rowId, czxxType) {
      this.czxxId = rowId;
      this.czxxType = czxxType;
      this.getYfftgkhmx();
      this.visibleSeeLlmx = true;
    },
    // 查看已付费推广客户明细-列表
    getYfftgkhmx(){
      if(this.czxxType==1){
        let addParams = {
          ID: this.czxxId, // 付费推广id
          PageNumber: this.pageIndexLlmx, // 页码
          PageSize: 10, // 条数
        };
        getDeduction(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.seeLlmxList = data.resultObj.resultObj;
              this.totalRowsCountLlmx = data.resultObj.rowsCount;
            } else {
              this.seeLlmxList = []
            }
          } else {
            this.seeLlmxList = []
          }
        })
      }else {
        let obj = {
          brrid: this.czxxId, // 充值单主键ID
          pageindex: this.pageIndexLlmx, // 页码
          pagesize: 10, // 条数
        };
        postconsume(obj).then(data => {
          if (data.resultCode == 1) {
            this.seeLlmxList = data.resultObj.list;
            this.totalRowsCountLlmx = data.resultObj.totalcount;
          } else {
            this.seeLlmxList = []
          }
        })
      }
    },
    // 查看已付费推广客户明细-分页
    handleLlmx(val) {
      this.pageIndexLlmx = val;
      this.getYfftgkhmx();
    },
    // 新增推广 & 查看配置 获取配置详情
    seepeizhi(row) {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      this.isshowfffxtg=false;
      if(row){ // 查看
        this.seefffxtg=true; // 查看标识
        this.date1 = row.begindate.replace(/\./g,'-');
        this.date2 = row.enddate.replace(/\./g,'-');
        this.value6 = [this.date1,this.date2];
        let params={
          shopid: this.bbid, // 店铺ID
          activityid: 0, // 活动ID
          brrid: row.brrid?row.brrid:0, // 充值单ID
        }
        configtaskType(params, 1).then(data => {
          if (data.resultCode == 1) {
            this.tasktyps = data.resultObj.tasktyps; // 任务类型集合
            this.recharge = data.resultObj.recharge; // 配置记录(充值单记录)
            row.brrid?'':this.recharge.remark='';
            row.brrid?'':this.recharge.totalcount='';
            this.rewardTwo = data.resultObj.univalence; // 单价 单位：元
            this.wxrate = data.resultObj.wxrate; // 微信手续费 默认0.006
            
            let hy = data.resultObj.filters.industry; // 行业ID集合
            if(hy[0]==0){
              this.formmenuOne = this.industry.map(item =>item.id); // 处理为全部选中状态
            }else {
              this.formmenuOne = hy;
              hy.length==5?this.isIndeterminateOne = false:this.isIndeterminateOne = true;
            }
            let pl = data.resultObj.filters.category; // 品类ID集合
            if(pl[0]==0){
              this.$refs.tree.setCheckedNodes(this.category); // 处理为全部选中状态
            }else{
              this.$refs.tree.setCheckedKeys(pl);
              this.isIndeterminateTwo = true;
            }
            
          }
        })
      }else{ // 新增
        this.seefffxtg=false; // 查看标识
        this.formmenuOne = this.industry.map(item =>item.id);
        // this.$refs.tree.setCheckedNodes(this.category);
        let params={
          shopid: this.bbid, // 店铺ID
          activityid: 0, // 活动ID
          brrid: 0, // 充值单ID
        }
        configtaskType(params, 1).then(data => {
          if (data.resultCode == 1) {
            this.tasktyps = data.resultObj.tasktyps; // 任务类型集合
            this.recharge = data.resultObj.recharge; // 配置记录(充值单记录)
            this.fxdpyq = this.recharge.bttids?this.recharge.bttids[0]:this.tasktyps[0].bttid;
            this.rewardTwo = data.resultObj.univalence; // 单价 单位：元
            
            this.value6 = []; // 手动清空 有效期限
            this.date1 = '';
            this.date2 = '';
            this.recharge.remark=''; // 手动清空 分享文案
            this.recharge.totalcount=''; // 手动清空 奖励份数
            this.recharge.totalprice=0; // 手动清空 充值金额
            
            this.wxrate = data.resultObj.wxrate; // 微信手续费 默认0.006
            let hy = data.resultObj.filters.industry; // 行业ID集合
            if(hy[0]==0){
              this.formmenuOne = this.industry.map(item =>item.id); // 处理为全部选中状态
            }else {
              this.formmenuOne = hy;
              hy.length==5?this.isIndeterminateOne = false:this.isIndeterminateOne = true;
            }
            let pl = data.resultObj.filters.category; // 品类ID集合
            if(pl[0]==0){
              this.$refs.tree.setCheckedNodes(this.category); // 处理为全部选中状态
            }else{
              this.$refs.tree.setCheckedKeys(pl);
              this.isIndeterminateTwo = true;
            }
          }
        })
      }
    },
    // 请选择店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              // this.bbid = data.resultObj[0].id; // 店铺id
              // this.gonext();
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else {
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id; // 店铺id
              this.bbtype = data.resultObj[0].shopType; // 店铺类型
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        }
      })
    },
    // 获取店铺类型
    handleChangedptype(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.bbtype = item.shopType;
        }
      })
    },
    gonext(){
      console.log(this.bbid)
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.getinit(); // 查询列表
      this.amountOfmoney(); // 获取推广客户单价
      this.browse(); // 需进店浏览次数
      this.promotionRules(); // 店铺推广规则信息详情
      this.dialogVisibleadd = false;


      this.chaxun();
      this.formmenuOne = this.industry.map(item =>item.id);
      this.$refs.tree.setCheckedNodes(this.category);
      let params={
        shopid: this.bbid, // 店铺ID
        activityid: 0, // 活动ID
        brrid: 0, // 充值单ID
      }
      configtaskType(params, 1).then(data => {
        if (data.resultCode == 1) {
          this.tasktyps = data.resultObj.tasktyps; // 任务类型集合
          this.recharge = data.resultObj.recharge; // 配置记录(充值单记录)
          this.fxdpyq = this.recharge.bttids?this.recharge.bttids[0]:this.tasktyps[0].bttid;
          this.rewardTwo = data.resultObj.univalence; // 单价 单位：元
          
          this.value6 = []; // 手动清空 有效期限
          this.date1 = '';
          this.date2 = '';
          this.recharge.remark=''; // 手动清空 分享文案
          this.recharge.totalcount=''; // 手动清空 奖励份数
          this.recharge.totalprice=0; // 手动清空 充值金额
          
          this.wxrate = data.resultObj.wxrate; // 微信手续费 默认0.006
          let hy = data.resultObj.filters.industry; // 行业ID集合
          if(hy[0]==0){
            this.formmenuOne = this.industry.map(item =>item.id); // 处理为全部选中状态
          }else {
            this.formmenuOne = hy;
            hy.length==5?this.isIndeterminateOne = false:this.isIndeterminateOne = true;
          }
          let pl = data.resultObj.filters.category; // 品类ID集合
          if(pl[0]==0){
            this.$refs.tree.setCheckedNodes(this.category); // 处理为全部选中状态
          }else{
            this.$refs.tree.setCheckedKeys(pl);
            this.isIndeterminateTwo = true;
          }
        }
      })


      
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  created() {
    this.tankuang(); // 初始化弹框
    this.getfilterlist(); // 获取树列集合
  },

};
</script>
<style scoped>
.zysmUl {
  line-height: 26px;
  margin-bottom: 20px;
}
.upBtn {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 视频 & 图片 集合 */
.videoandpic {
  width: 96%;
  margin: 0 auto;
  position: relative;
  display: inline-block;
  margin-top: 10px;
}
.videoandpic>li{
  float: left;
  margin: 0 10px 5px 0;
  cursor: pointer;
  position: relative;
}
.mengceng {
  position: absolute;
  left: 30px;
  top: 30px;
  font-size: 40px;
  color: #666;
}
.pkuandu{
  width: 360px;
}
</style>


// WEBPACK FOOTER //
// paidPromotion.vue?d027b8ea